import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LabelBaseComponent } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelWebComponent extends LabelBaseComponent {}
